module.exports = __webpack_public_path__ + "img/card-loyal1.e3bb1314.svg";